import axios from "axios";

// ============================================================
//  API INTERNA (backend local — para contacto y otros)
// ============================================================
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// ============================================================
//  API UNEMI POSGRADOS — proxy local (evita CORS)
//  En dev: petición va a /proxy/unemi/maestrias (craco devServer la reenvía)
//  En prod: petición va a /proxy/unemi/maestrias (debe configurarse en el servidor)
// ============================================================
const PROXY_URL = "/proxy/unemi/maestrias";

export function clasificarEscuela(nombre) {
    const n = (nombre || "").toUpperCase();
    if (["EDUCACI", "ENSEÑANZ", "COMUNICAC", "ESPAÑOL", "PEDAGOG", "LING"].some(k => n.includes(k))) return "educacion-comunicacion";
    if (["TECNOLOG", "INFORM", "INGENIER", "SOFTWARE", "CIBERS", "DATOS", "INTELIGENCIA ARTIFICIAL", "AGROPEC", "INDUSTR"].some(k => n.includes(k))) return "ciencias-ingenieria";
    if (["ADMINISTRAC", "EMPRESA", "MARKETING", "FISCAL", "ADUAN", "FINANZ", "CONTAB", "AUDIT", "NEGOCIO", "MANAG", "TURIS", "GESTI", "ECONOM"].some(k => n.includes(k))) return "negocios";
    if (["SALUD", "ENFERMER", "MEDIC", "NUTRIC", "PSIC"].some(k => n.includes(k))) return "salud";
    if (["DERECHO", "TRABAJO SOCIAL", "JURÍD", "JURID", "PROCESAL", "PENAL", "SOCIAL"].some(k => n.includes(k))) return "derecho";
    return "derecho";
}

/**
 * Obtiene maestrías desde la API oficial de UNEMI (vía proxy local).
 * Filtra solo las que tienen ofertada=true Y al menos una cohorte abierta con precio.
 */
export async function fetchMaestrias(escuela) {
    try {
        const { data } = await axios.get(PROXY_URL);
        // La API devuelve { success: true, data: [...] }
        const todas = data?.data || [];

        // Filtrar: solo ofertadas con al menos 1 cohorte abierta y con precio
        let filtradas = todas.filter(
            (m) =>
                m.ofertada === true &&
                Array.isArray(m.cohortes_inscripcion_abierta) &&
                m.cohortes_inscripcion_abierta.length > 0 &&
                m.cohortes_inscripcion_abierta.some((c) => c.valor_programa > 0)
        );

        if (escuela) {
            filtradas = filtradas.filter((m) => clasificarEscuela(m.nombre_maestria) === escuela);
        }

        return { data: filtradas };
    } catch (err) {
        console.error("[fetchMaestrias] Error:", err.message);
        return { data: [] };
    }
}

export async function fetchMaestria(pk) {
    try {
        const { data: allData } = await fetchMaestrias();
        return (allData || []).find((m) => String(m.pk) === String(pk)) || null;
    } catch {
        return null;
    }
}

export async function enviarContacto(payload) {
    const { data } = await apiClient.post("/contacto", payload);
    return data;
}

// ============================================================
//  Utilidades de formato
// ============================================================
export const formatUSD = (value) =>
    new Intl.NumberFormat("es-EC", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
    }).format(value || 0);

export const formatDate = (iso) => {
    if (!iso) return "-";
    const d = new Date(iso);
    return d.toLocaleDateString("es-EC", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });
};

